export default __webpack_public_path__ + "assets/images/09a200e6d5927415920ca85bd04e8d4a.svg";